module.exports = __webpack_public_path__ + "img/over-the-city-soldier.01f95155.png";